<template>
  <div class="col-xl-12">
    <div class="card">
      <div class="card-header">
        <h3 class="p-0">
          <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapseicon2"
            :aria-expanded="isActive ? 'true' : 'false'" aria-controls="collapseicon2" :class="[isActive ? 'active' : '']"
            v-on:click="toggle">About Me</button>
        </h3>
      </div>
      <div :class="[isActive ? 'block' : ' show']" v-show="isActive">
        <div class="card-body post-about">
          <ul>
            <li>
              <div class="icon"><i data-feather="briefcase"><vue-feather type="briefcase"
                    class="facebook"></vue-feather></i></div>
              <div>
                <h5>UX desginer at Pixelstrap</h5>
                <p>banglore - 2022</p>
              </div>
            </li>
            <li>
              <div class="icon"><vue-feather type="book"></vue-feather></div>
              <div>
                <h5>studied computer science</h5>
                <p>at london univercity - 2015</p>
              </div>
            </li>
            <li>
              <div class="icon"><vue-feather type="heart"></vue-feather></div>
              <div>
                <h5>relationship status</h5>
                <p>single</p>
              </div>
            </li>
            <li>
              <div class="icon"><vue-feather type="map-pin"></vue-feather></div>
              <div>
                <h5>lived in london</h5>
                <p>last 5 year</p>
              </div>
            </li>
            <li>
              <div class="icon"><vue-feather type="droplet"></vue-feather></div>
              <div>
                <h5>blood group</h5>
                <p>O+ positive</p>
              </div>
            </li>
          </ul>
          <div class="social-network theme-form"><span class="f-w-600">Social Networks</span><a
              class="btn social-btn btn-fb mb-2 text-center" href="https://www.facebook.com" target="_blank"><i
                class="fa fa-facebook m-r-5"></i>Facebook</a><a class="btn social-btn btn-twitter mb-2 text-center"
              href="https://www.twitter.com" target="_blank"><i class="fa fa-twitter m-r-5"></i>Twitter</a><a
              class="btn social-btn btn-google text-center" href="https://www.dribbble.com" target="_blank"><i
                class="fa fa-dribbble m-r-5"></i>Dribbble</a></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'aboutMe',
  data() {
    return {
      isActive: true,
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
    },
  }
}
</script>